<template>
    <div class="dropzone-control">
        <blank-state v-if="$root.loading('dropzone.uploading')" :inner="true">
            <div slot="title">Uploading files</div>

            <div slot="content">
                <div class="mb-20">We are uploading your files, this may take a few minutes.</div>

                <loader />
            </div>
        </blank-state>

        <div id="dropzone" class="dropzone" v-show="!$root.loading('dropzone.uploading')">
            <i class="far fa-upload"></i>
        </div>
    </div>
</template>

<script>
    import { getMeta } from '../../../helpers';
    import Dropzone from 'dropzone';
    Dropzone.autoDiscover = false;

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'Dropzone',

        /**
         * The component props
         *
         * @type {Object}
         */
        props: {
            /**
             * The upload URL
             */
            url: {
                type:     String,
                required: true
            },

            /**
             * The maximum allowed file size in MB
             */
            maxFileSize: {
                type:    [Number, String],
                default: 256
            }
        },

        /**
         * The component methods
         *
         * @param {Object}
         */
        methods: {
            /**
             * A file added to the upload queue
             */
            handleAddedFile() {
                if (!this.$root.loading('dropzone.uploading')) {
                    this.$root.loaderStart('dropzone.uploading');
                }
            },

            /**
             * A file successfully uploaded
             *
             * @param {File} f
             * @param {Array} files
             */
            handleSuccess(f, files) {
                files.forEach(file => this.$emit('uploaded', file));
            },

            /**
             * Error uploading a file
             *
             * @param {File} file
             * @param {Object} data
             */
            handleError(file, data) {
                this.$requestErrors({ data });
            },

            /**
             * Upload queue is empty
             */
            handleQueueComplete() {
                this.$root.loaderStop('dropzone.uploading');
            }
        },

        /**
         * The the component is mounted
         */
        mounted() {
            (new Dropzone('div#dropzone', {
                url:                this.url,
                maxFileSize:        this.maxFileSize,
                parallelUploads:    5,
                timeout:            480000,
                paramName:          'files[]',
                acceptedFiles:      'image/*, video/*, application/pdf',
                autoProcessQueue:   true,
                headers:            { 'X-CSRF-TOKEN': getMeta('csrf-token') },
                dictDefaultMessage: 'Drop files here or <span>click to upload</span>',
                previewTemplate:    '<div style="display: none"></div>'
            }))
                .on('addedfile',     this.handleAddedFile)
                .on('success',       this.handleSuccess)
                .on('error',         this.handleError)
                .on('queuecomplete', this.handleQueueComplete)
            ;
        }
    }
</script>